import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

export default function TrackingRedirect() {
 const { pathname, search, hash } = useLocation()
 return <Navigate replace to={{ pathname: pathname.replace(/^\/tracking(?=\/|$)/i, '/track'), search, hash }} />
}
